import { render, staticRenderFns } from "./GoodsOffersTable.vue?vue&type=template&id=4c031112"
import script from "./GoodsOffersTable.vue?vue&type=script&lang=ts"
export * from "./GoodsOffersTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports